// Azka Vision Routes
// Follows the following convention : Persona-screen-description
// E.g. persona : analytics , screen: gates live => analytics-gates-live
export const routes = {
  home: "",
  subscriptionEnd: "subscription-ended",
  noPermissions: "no-permissions",
  campaign: "marketing-campaign-planner",
  404: "404",

  // Multiple Branches Routes
  branchesGatesAnalytics: "branches-gates-analytics",
  branchesCamerasConnectivity: "branches-cameras-connectivity",
  branchesNodesConnectivity: "branches-nodes-connectivity",
  branchesCategories: "branches-categories",

  // Analytics Routes
  dwelling: "analytics-dwelling-areas",
  dwellingAreas: "analytics-dwelling-areas",
  dwellingAreaDetails: "analytics-dwelling-area-details",
  gates: "analytics-entrance-gates",
  liveGates: "analytics-gates-live",
  historyGates: "analytics-gates-history",
  categories: "analytics-categories",
  tenantsList: "analytics-tenants-list",
  tenantDetails: "analytics-tenant-details",
  missingData: "analytics-missing-data",
  corridors: "analytics-corridors",
  carsAnalytics: "analytics-cars-statistics",
  oldHeatmap: "analytics-old-heatmap",
  heatmap: "analytics-heatmap",
  staffOccupancy: "analytics-staff-occupancy",
  seatOccupancy: "analytics-seat-occupancy",
  floorsMCP: "analytics-floors-MCP",
  camerasMCP: "analytics-cameras-MCP",
  checkoutCounter: "analytics-checkout-counter",
  customerService: "analytics-customer-service",

  // Admin Routes
  cameraHealth: "admin-camera-health",
  newCamera: "admin-camera-list/add-new-camera",
  cameraList: "admin-camera-list",
  cameraDetails: "admin-camera-list/admin-camera-details",
  cameraViewChanges: "admin-camera-view-changes",
  entitiesAndRegions: "admin-entities-and-regions",
  intrusionSetup: "admin-intrusion-setup",
  motionSetup: "admin-motion-setup",
  nodesList: "admin-nodes-list",
  nodeDownAnalytics: "admin-nodes-list/admin-node-down-analytics",
  uploadFootage: "admin-camera-list/uploadFootage",
  users: "admin-users-panel",
  createUser: "admin-users-panel/admin-create-user",
  userDetails: "admin-users-panel/:id",
  carsList: "admin-cars-lists",
  categoriesList: "admin-categories-list",
  floors: "admin-floor",
  apiIntegration: "admin-API-integration",
  license: "admin-license",
  defectDetectionSetup: "admin-defect-detection-setup",

  // Security Routes
  carsLogs: "security-cars-logs",
  liveStreams: "security-live-streams",
  securityIncidents: "security-incidents",
  faceRecognition: "security-face-recognition",
  profileVisits: "security-profile-visits",

  // Industrial Routes
  defectDetection: "industrial-defect-detection",
}
